import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Checkbox from '../Atoms/Checkbox';
import Input from '../Atoms/Input';

const propTypes = exact({
  handleChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLinkedBooking: PropTypes.bool,
  linkedBookingHeadingText: PropTypes.string,
  linkedBookingLabelText: PropTypes.string,
  linkedBookingName: PropTypes.string,
  linkedBookingNameLabelText: PropTypes.string,
  linkedBookingNamePlaceholderText: PropTypes.string,
  linkedBookingReference: PropTypes.string,
  linkedBookingReferenceLabelText: PropTypes.string,
  linkedBookingReferencePlaceholderText: PropTypes.string,
});

const defaultProps = {
  handleChange: () => false,
  handleFieldChange: () => false,
  isDisabled: false,
  isLinkedBooking: false,
  linkedBookingHeadingText: '',
  linkedBookingLabelText: '',
  linkedBookingName: '',
  linkedBookingNameLabelText: '',
  linkedBookingNamePlaceholderText: '(i.e. Mr J Doe)',
  linkedBookingReference: '',
  linkedBookingReferenceLabelText: '',
  linkedBookingReferencePlaceholderText: '(i.e. A00001)',
};

function LinkedBookings(props) {
  const linkedBookingsInner = classNames('LinkedBookings_inner', {
    active: props.isLinkedBooking !== false,
  });

  return (
    <div className="LinkedBookings">
      {props.isDisabled && (
        <div className="LinkedBookings_summaryItem">
          <h3 className="LinkedBookings_heading">{props.linkedBookingHeadingText}</h3>
          <div className="LinkedBookings_summaryContainer">
            <div className="LinkedBookings_summaryForm">
              <div className="LinkedBookings_title-summary">{props.linkedBookingNameLabelText}</div>
              <div>{props.linkedBookingName}</div>
            </div>
            <div className="LinkedBookings_summaryForm">
              <div className="LinkedBookings_title-summary">
                {props.linkedBookingReferenceLabelText}
              </div>
              <div> {props.linkedBookingReference} </div>
            </div>
          </div>
        </div>
      )}
      {!props.isDisabled && (
        <>
          <div className="LinkedBookings_headerContainer">
            <h3 className="LinkedBookings_heading">{props.linkedBookingHeadingText}</h3>
            <Checkbox
              blockName="LinkedBookings_checkbox"
              fieldID="isLinkedBooking"
              fieldName="isLinkedBooking"
              fieldValue="false"
              handleChange={props.handleChange}
              inputType="checkbox"
              isChecked={props.isLinkedBooking}
              isDisabled={false}
              modifier="ghost"
            />
            <div className="LinkedBookings_label">{props.linkedBookingLabelText}</div>
          </div>
          <div className={linkedBookingsInner}>
            <div className="LinkedBookings_fieldContainer">
              <div className="LinkedBookings_field">
                <h4 className="LinkedBookings_title">{props.linkedBookingReferenceLabelText}</h4>
                <Input
                  blockName="LinkedBookings_input"
                  fieldName="linkedBookingReference"
                  fieldValue={props.linkedBookingReference}
                  handleChange={props.handleFieldChange}
                  inputType="text"
                  modifier="ghost"
                  placeholderText={props.linkedBookingReferencePlaceholderText}
                />
              </div>
              <div className="LinkedBookings_field">
                <h4 className="LinkedBookings_title">{props.linkedBookingNameLabelText}</h4>
                <Input
                  blockName="LinkedBookings_input"
                  fieldName="linkedBookingName"
                  fieldValue={props.linkedBookingName}
                  handleChange={props.handleFieldChange}
                  inputType="text"
                  modifier="ghost"
                  placeholderText={props.linkedBookingNamePlaceholderText}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

LinkedBookings.propTypes = propTypes;
LinkedBookings.defaultProps = defaultProps;

export default LinkedBookings;
